import {combineReducers} from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import HomeReducer from './reducers/HomeReducer';
import listingReducer from './reducers/listingReducer';
import detailReducer from './reducers/detailReducer';
import cartReducer from './reducers/cartReducer';
import checkoutReducer from './reducers/checkoutReducer';
import thankyouReducer from './reducers/thankyouReducer';
import contactReducer from './reducers/contactReducer';
import dataProtectionReducer from './reducers/dataProtectionReducer';
import TermsConditionsReducer from './reducers/TermsConditionsReducer';
import GalleryCollectionReducer from './reducers/GalleryCollectionReducer';
import OurLabsReducer from './reducers/OurLabsReducer';
import FramesReducer from './reducers/FramesReducer';
import QualityPrintsReducer from './reducers/QualityPrintsReducer';
import AuthReducer from './reducers/AuthReducer';
import OrderDetailReducer from './reducers/OrderDetailReducer';
 import WishlistReducer from './reducers/wishlistReducer';
 import CreditSlipReducer from './reducers/CreditSlipReducer';
import languageReducer from './reducers/LanguagesReducer';
import recentlyViewedSlice from './reducers/recentlyViewedSlice';

// Persist only the auth flag; the user/customer data is re-fetched from the
// server session (CCheckAuth_sync) and must not be kept in localStorage.
const authPersistConfig = {
    key: 'sg-v3-auth',
    version: 3,
    storage,
    whitelist: ['isAuthenticated'],
  };
  const rootReducer = combineReducers({
    // user :   UserReducer,
    home :  HomeReducer,
    shop :  listingReducer,
    product_detail :  detailReducer,
    recentlyViewedProducts: recentlyViewedSlice,
    // storelist: StorelistReducer,
    checkoutpage:checkoutReducer,
    cartpage:cartReducer,
    thankyoupage:thankyouReducer,
    contactpage:contactReducer,
    dataprotectionpage:dataProtectionReducer,
    termsconditionspage:TermsConditionsReducer,
    gallerycollectionpage:GalleryCollectionReducer,
    ourlabspage:OurLabsReducer,
    framespage:FramesReducer,
    qualityprintspage:QualityPrintsReducer,
    auth:persistReducer(authPersistConfig, AuthReducer),
    orderdetail:OrderDetailReducer,
        wishlistpage:WishlistReducer,
        creditslip:CreditSlipReducer,
    languages:languageReducer
    // order:OrderReducer,
    // category:CategoryReducer,
    // brand:BrandReducer,
    // offer:OfferReducer,
    // legal:legalReducer,
    // review:ReviewReducer,
    // currency:CurrencyReducer
  })
 
export default rootReducer;